

import getAspectRatios from '../constants/aspectRatios';

const PREFIX_ICON = 'square';

const ADDITIONAL_OUTPUT_TITLE = 'Social Iterations';

function getAdditionalOutput(options) {
  return {
    captionValue: {
      ...options.captionValue
    },
    title: options.title,
    type: options.type
  };
}

function getCurrentAspectRationOption(aspectRatio) {
  const [currentAspectRatioOption] = getAspectRatios().filter(
    (optionRatio) => optionRatio.value === aspectRatio && optionRatio.label
  );
  return currentAspectRatioOption;
}

export default function getAdditionalOutputs() {
  return (addons) => {
    const additionalOutputValue = addons && addons.ADDITIONAL_OUTPUT || [];

    const additionalOutputValues = additionalOutputValue.map((supersize) => {
      const { label } = getCurrentAspectRationOption(supersize.aspectRatio);

      return getAdditionalOutput({
        captionValue: {
          label,
          value: supersize.value,
          cost: supersize.cost,
          prefix: PREFIX_ICON
        },
        type: addons.ADDITIONAL_OUTPUT[0].value,
        title: ADDITIONAL_OUTPUT_TITLE
      });
    });

    return [...additionalOutputValues].filter(Boolean);
  };
}